import React, { useState } from 'react';
import { Form, Input, Button, Checkbox, Card, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { login } from '../../api/auth';
import { setUserInfo } from '../../store/slices/userSlice';
import { setToken, setUserInfo as saveUserInfo, setUserRole } from '../../utils/auth';
import { getMenuItemsByRole } from '../../router/routes';
import './index.css';

// 登录后跳转：有 Dashboard 权限跳工作台，否则跳第一个可见菜单（如视频上传专员仅见"视频上传"）
const resolveLandingPath = (role) => {
  const menus = getMenuItemsByRole(role);
  const dashboard = menus.find((item) => item.path === '/dashboard');
  if (dashboard) return '/dashboard';
  const first = menus.find((item) => item.children?.length > 0 || item.path);
  return first?.children?.[0]?.path || first?.path || '/403';
};

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const response = await login(values);
      if (response.code === 0 || response.success) {
        const { accessToken, refreshToken, userInfo } = response.data;
        setToken(accessToken, refreshToken);
        saveUserInfo(userInfo);
        if (userInfo?.role) {
          setUserRole(userInfo.role);
        }
        dispatch(setUserInfo(userInfo));
        message.success('登录成功');
        navigate(resolveLandingPath(userInfo?.role));
      } else {
        message.error(response.message || '登录失败');
      }
    } catch (error) {
      message.error(error.message || '登录失败，请检查账号密码');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="login-card">
      <div className="login-header">
        <h1 className="login-title">寻医问病平台</h1>
        <p className="login-subtitle">系统管理后台</p>
      </div>

      <Form
        name="login"
        onFinish={handleSubmit}
        autoComplete="off"
        layout="vertical"
        initialValues={{ remember: true }}
      >
        <Form.Item
          name="username"
          rules={[{ required: true, message: '请输入管理员账号' }]}
        >
          <Input
            prefix={<UserOutlined />}
            placeholder="管理员账号"
            size="large"
          />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[{ required: true, message: '请输入密码' }]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="密码"
            size="large"
          />
        </Form.Item>

        <Form.Item name="remember" valuePropName="checked">
          <Checkbox>记住密码</Checkbox>
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            block
            size="large"
            className="login-btn"
          >
            登录
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default Login;
